module.exports = __webpack_public_path__ + "static/media/profile_picture.9f59d59d.png";